<div class="sso-fast-container form-container">
  <div class="sso-fast-content text-center">
    <div class="spinner-border text-primary" role="status" aria-hidden="false" aria-label="Caricamento">
      <span class="visually-hidden">Caricamento...</span>
    </div>
    <p class="mt-3 text-muted mb-0">Reindirizzamento...</p>
  </div>
</div>
